import { v4 as uuidv4 } from 'uuid';
import { CpfCnpjPipe } from '../shared/cpf-cnpj.pipe';

export class Util {

	public static readonly NGX_MASK_CPF = '000.000.000-00';
	public static readonly NGX_MASK_CNPJ = 'AA.AAA.AAA/AAAA-00';

	public static hasLetters(value: string): boolean {
		return /[a-zA-Z]/.test(value);
	}

	public static handleCpfCnpjKeydown(event: KeyboardEvent): void {
		if (['Backspace', 'Tab', 'Escape', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(event.key) !== -1 ||
			(event.key === 'a' && (event.ctrlKey || event.metaKey)) ||
			(event.key === 'c' && (event.ctrlKey || event.metaKey)) ||
			(event.key === 'v' && (event.ctrlKey || event.metaKey)) ||
			(event.key === 'x' && (event.ctrlKey || event.metaKey))) {
			return;
		}
		if (!/^[a-zA-Z0-9]$/.test(event.key)) {
			event.preventDefault();
			return;
		}
		const rawLength = Util.removeMaskCharacters((event.target as HTMLInputElement).value).length;
		if (rawLength >= 12 && Util.hasLetters(event.key)) {
			event.preventDefault();
			return;
		}
		if ((event.target as HTMLInputElement).value && (event.target as HTMLInputElement).value.length >= 18) {
			event.preventDefault();
		}
	}

	static copyToClipboard(val: string) {
		const selBox = document.createElement('textarea');
		selBox.style.position = 'fixed';
		selBox.style.left = '0';
		selBox.style.top = '0';
		selBox.style.opacity = '0';
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
	}


	static toCamel(str: string) {
		return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) { // (/\s+/.test(match)) for white spaces
			if (+match === 0) { return ''; }
			return index === 0 ? match.toLowerCase() : match.toUpperCase();
		});
	}

	static keysToCamel(o: any) {
		if (o === Object(o) && !Array.isArray(o) && typeof o !== 'function') {
			const n = {};
			Object.keys(o)
				.forEach((k) => {
					n[this.toCamel(k)] = this.keysToCamel(o[k]);
				});
			return n;
		} else if (Array.isArray(o)) {
			return o.map((i) => {
				return this.keysToCamel(i);
			});
		}
		return o;
	}

	static generateGUID(): string {
		let guid = '';
		const GUIDMask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

		guid = GUIDMask.replace(/[xy]/g, function (c) {
			const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});

		return guid;
	}

	static generateUUID4(): string {
		return uuidv4();
	}
	public static formatCpfCnpj(str: string): string {
		if (str.length === 11) {
			return str.substring(0, 3).concat('.')
				.concat(str.substring(3, 6))
				.concat('.')
				.concat(str.substring(6, 9))
				.concat('-')
				.concat(str.substring(9, 11));
		} else if (str.length === 14) {
			return str.substring(0, 2).concat('.')
				.concat(str.substring(2, 5))
				.concat('.')
				.concat(str.substring(5, 8))
				.concat('/')
				.concat(str.substring(8, 12))
				.concat('-')
				.concat(str.substring(12, 14));
		}

		return str;
	}

	public static formatPhone(str: string): string {
		str = str.replace(/\D/g, '');

		if (str.length === 11) {
			str = str.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
		} else if (str.length === 13) {
			str = str.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, '+$1 ($2) $3-$4');
		} else {
			str = str.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
		}

		return str;
	}

	public static removeCnpjCharacters(cpfCnpj: string): string {
		return cpfCnpj.replace(/[\.\-\/]/g, '');
	}

	public static removeMaskCharacters(value: string): string {
		return value.replace(/[\.\-\/\s]/g, '');
	}

	public static maskCpfCnpj(str: string): string {
		str = this.removeMaskCharacters(str).toUpperCase();

		if (str.length === 0) {
			return '';
		}

		if (this.hasLetters(str) || str.length > 11) {
			let result = str.substring(0, 2);
			if (str.length > 2) result += '.' + str.substring(2, 5);
			if (str.length > 5) result += '.' + str.substring(5, 8);
			if (str.length > 8) result += '/' + str.substring(8, 12);
			if (str.length > 12) result += '-' + str.substring(12, 14);
			return result;
		}

		if (str.length <= 3) {
			return str;
		} else if (str.length <= 6) {
			return str.replace(/^(\d{0,3})(\d{0,3})/, '$1.$2');
		} else if (str.length <= 9) {
			return str.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1.$2.$3');
		} else if (str.length <= 11) {
			return str.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '$1.$2.$3-$4');
		}
	}

	public static maskCpfCnpjPix(str: string): string {
		const CPF_LENGTH = 11;
		const CNPJ_LENGTH = 14;

		if (!str) {
			return '';
		}

		if (str.includes('***')) {
			return str;
		}

		const raw = this.removeMaskCharacters(str);

		if (this.hasLetters(raw) || raw.length > CPF_LENGTH) {
			if (raw.length <= CNPJ_LENGTH) {
				return raw.substring(0, 2) + '.' + raw.substring(2, 5) + '.' + raw.substring(5, 8) + '/' + raw.substring(8, 12) + '-' + raw.substring(12);
			}
			return str;
		}

		const cpfCnpj = this.removeNonNumerics(str);

		if (cpfCnpj.length <= CPF_LENGTH) {
			return cpfCnpj.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, '***.$2.$3-**');
		}
	}

	public static maskAccount(str: string): string {
		str = this.removeNonNumerics(str);
		if (str.length === 0) {
			return '';
		} else if (str.length <= 21) {
			return str.replace(/^(\d{0,20})*(\d{1})/, '$1-$2');
		}
	}

	public static removeNonNumerics(value: string) {
		if (value.length === 0) {
			return '';
		}

		const trimedValue = value.trim()

		return trimedValue.replace(/\D/g, '');
	}

	public static formatValue(value: any, signal = false) {
		if (Number(value) < 0) {
			value = '- R$ ' + (Number(value) * -1).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
		} else if (Number(value) > 0) {
			value = '+ R$ ' + Number(value).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
		} else {
			value = 'R$ ' + Number(value).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
		}

		if (!signal) {
			value = value.replace('- ', '');
			value = value.replace('+ ', '');
		}
		return value;
	}

	public static DateAddDay(days: number): Date {
		const date = new Date();
		date.setDate(date.getDate() + days);
		return date;
	}

	public static formatDateToDayAndMonth(date: string): string {
		let month = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
		let spreadDate = date.split('/');
		return spreadDate[0] + ' ' + month[parseInt(spreadDate[1])];
	}

	static camelCaseText(name: string): string {
		if (!name) {
			return '';
		}

		return name.toLowerCase().replace(/(?:^|\s|\.|\/)\S/g, function (a) {
			return a.toUpperCase();
		});
	}

	static isToday(date: Date): boolean {
		const today = new Date();
		return (
			date.getDate() === today.getDate() &&
			date.getMonth() === today.getMonth() &&
			date.getFullYear() === today.getFullYear()
		);
	}

	static isDigitableLine(code?: string): boolean | void {
		if (code) {
			code = code.split(' ').join('');
			const minimumPaymentCharacters = 47;
			const codeCharacters = code.length;
			return codeCharacters >= minimumPaymentCharacters
		}
	}

	static allowedCharactersRegex = /^([0-9A-Za-zÀ-ÖØ-öø-ÿ -\/\@\_\=\{\}\~\;\?\<\>\:]+)$/;
	
	static isMobile(): boolean {
	  const mobileRegex = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|BlackBerry|webOS|Windows Phone/i;
	  return mobileRegex.test(navigator.userAgent);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/utils/util.ts